import { css } from '@emotion/react'
import { CSSProperties, memo } from 'react'
import { palette } from '../../../styles/colors'

const USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})

const rootStyles = css({
    alignItems: 'center',
    fontWeight: 500,
    display: 'flex',
})
const rankStyles = css({ fontWeight: 'bold' })
const prizeStyles = css({
    color: palette.greenMFC,
    fontWeight: 'bold',
    marginLeft: 2,
})

interface MissMFCBannerProps {
    missMFCPrize?: number
    missMFCRank: number
    rankStyleOverrides?: CSSProperties
    styleOverrides?: CSSProperties
    text?: string
}

const MissMFCBanner = memo((props: MissMFCBannerProps) => {
    const {
        rankStyleOverrides = {},
        styleOverrides = {},
        text = 'Miss MFC',
        missMFCPrize,
        missMFCRank,
    } = props

    return (
        <div
            css={rootStyles}
            style={{
                justifyContent: missMFCPrize ? 'space-between' : 'center',
                ...styleOverrides,
            }}
        >
            <div data-testid="Container__MissMFCRank">
                <span>{text}</span>
                <span
                    data-testid="Label__MissMFCRank"
                    css={rankStyles}
                    style={rankStyleOverrides}
                >
                    #{missMFCRank}
                </span>
            </div>
            {missMFCPrize && (
                <div>
                    <span>Prize:</span>
                    <span css={prizeStyles}>
                        {USDollar.format(missMFCPrize).replace('.00', '')}
                    </span>
                </div>
            )}
        </div>
    )
})

export default MissMFCBanner
export { MissMFCBanner }
